/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Texture, TilingSprite } from 'pixi.js-legacy';
/**
 * TickerOverlap default
 */
export interface ITicketOverlapDefaultState {
	active: boolean;
	renderable: boolean;
	mask: any;
}
export class TicketOverlap extends TilingSprite {
	public defaultState: ITicketOverlapDefaultState = {
		active: true,
		renderable: false,
		mask: null,
	};
	public active: boolean;
	constructor(texture: Texture) {
		super(texture);

		//this.zIndex = 15;
		this.alpha = 0.33;
		this.active = true;
		this.visible = true;
	}
}
